// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// Define a service using a base URL and expected endpoints
const userToken = JSON.parse(localStorage.getItem('user'))

const baseQuery = fetchBaseQuery({ 
  baseUrl: `${process.env.REACT_APP_BACKEND_API_URL}/api/`,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token
    if(token) {
      headers.set("Authorization", `Bearer ${token}`)
    }

    return headers
  } 
})


export const fullApi = createApi({
  reducerPath: "fullApi",
  baseQuery,
  tagTypes: ['Orders', 'Smartphones', 'Users', 'Brands', 'Carts', 'Headphones', 'Chargers', 'Phonecases'],
  endpoints: (builder) => ({

    //*ORDER API ENDPOINTS
    getAllOrders: builder.query({
      query: (user) => ({
          url: `orders`,
          headers: {
              'Authorization': `Bearer ${userToken?.accessToken}`
          }
        }),
      providesTags: ['Orders']
  }),
    getOrder: builder.query({
        query: (orderId) => ({
            url: `orders/${orderId}`,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
    }),
    getUserOrders: builder.query({
        query: (id) => ({
          url: `orders/find/${id}`,
          headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
        }
        }),
        providesTags: ['UserOrders']
    }),
    addOrder: builder.mutation({
        query: (order) => ({
            url: `orders/${order.userId}`,
            method: 'POST',
            body: order,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Orders']
    }),
    updateOrder: builder.mutation({
      query: (order) => ({
          url: `orders/${order._id}`,
          method: 'PUT',
          body: {...order},
          headers: {
              'Authorization': `Bearer ${userToken?.accessToken}`
          }
      }),
      invalidatesTags: ['Orders','UserOrders']
  }),
    deleteOrder: builder.mutation({
        query: ({id}) => ({
            url: `orders/${id}`,
            method: 'DELETE',
            body: id,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Orders', 'UserOrders']
    }),


    //*PRODUCT API ENDPOINTS
    getAllSmartphones: builder.query({
        query: () => `smartphones`,
        providesTags: ['Smartphones']
    }),
    getAllActiveSmartphones: builder.query({
      query: () => `smartphones/active`,
      providesTags: ['ActiveSmartphones']
    }),
    getAllInactiveSmartphones: builder.query({
      query: () => `smartphones/inactive`,
      providesTags: ['InactiveSmartphones']
    }),
    getSmartphone: builder.query({
      query: (smartphone) => `smartphone/${smartphone._id}`
    }),
    addSmartphone: builder.mutation({
        query: (smartphone) => ({
            url: 'smartphones',
            method: 'POST',
            body: smartphone,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Smartphones','InactiveSmartphones', 'ActiveSmartphones']
    }),
    updateSmartphone: builder.mutation({
        query: (smartphone) => ({
            url: `smartphones/${smartphone._id}`,
            method: 'PUT',
            body: {...smartphone},
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Smartphones','InactiveSmartphones', 'ActiveSmartphones']
    }),
    deleteSmartphone: builder.mutation({
        query: ({id}) => ({
            url: `smartphones/${id}`,
            method: 'DELETE',
            body: id,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Smartphones', 'ActiveSmartphones', 'InactiveSmartphones']
    }),


    //*USER API ENDPOINTS
    getAllUsers: builder.query({
        query: (user) => ({
            url: `users`,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
          }),
        providesTags: ['Users']
    }),
    getUser: builder.query({
      query: ({id}) => ({
        url: `users/find/${id}`,
        headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
        }
      }),
      providesTags: ['Users']
    }),
    updateUser: builder.mutation({
        query: (user) => ({
            url: `users/${user._id}`,
            method: 'PUT',
            body: {...user},
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Users']
    }),
    deleteUser: builder.mutation({
        query: ({id}) => ({
            url: `users/${id}`,
            method: 'DELETE',
            body: id,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Users']
    }),

    //*CART API ENDPOINTS
    getAllCarts: builder.query({
        query: () => ({
            url: `carts`,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
          }),
        providesTags: ['Carts']
      }),
      getCart: builder.query({
        query: (userId) => ({
          url: `carts/find/${userId}`,
          headers: {
              'Authorization': `Bearer ${userToken?.accessToken}`
          }
        }),
      }),
      addCart: builder.mutation({
          query: (cart) => ({
              url: 'carts',
              method: 'POST',
              body: cart,
              headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
              }
          }),
          invalidatesTags: ['Carts']
      }),
      updateCart: builder.mutation({
          query: (cart) => ({
              url: `carts/${cart._id}`,
              method: 'PUT',
              body: cart,
              headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
              },
          }),
          invalidatesTags: ['Carts']
      }),
      deleteCart: builder.mutation({
          query: ({id}) => ({
              url: `carts/${id}`,
              method: 'DELETE',
              body: id,
              headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
              }
          }),
          invalidatesTags: ['Carts']
      }),


    //*BRAND API ENDPOINTS
    getAllBrands: builder.query({
        query: () => ({
            url: `brands`,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
          }),
        providesTags: ['Brands']
      }),
      getBrand: builder.query({
        query: (userId) => ({
          url: `brands/find/${userId}`,
          headers: {
              'Authorization': `Bearer ${userToken?.accessToken}`
          }
        }),
      }),
      addBrand: builder.mutation({
          query: (brand) => ({
              url: 'brands',
              method: 'POST',
              body: brand,
              headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
              }
          }),
          invalidatesTags: ['Brands']
      }),
      updateBrand: builder.mutation({
          query: (brand) => ({
              url: `brands/${brand._id}`,
              method: 'PUT',
              body: brand,
              headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
              },
          }),
          invalidatesTags: ['Brands']
      }),
      deleteBrand: builder.mutation({
        query: ({id}) => ({
            url: `brands/${id}`,
            method: 'DELETE',
            body: id,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Brands']
    }),

        //*BRAND API ENDPOINTS
        getAllMaterials: builder.query({
          query: () => ({
              url: `materials`,
              headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
              }
            }),
          providesTags: ['Materials']
        }),
        addMaterial: builder.mutation({
            query: (material) => ({
                url: 'materials',
                method: 'POST',
                body: material,
                headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
                }
            }),
            invalidatesTags: ['Materials']
        }),
        updateMaterial: builder.mutation({
            query: (material) => ({
                url: `materials/${material._id}`,
                method: 'PUT',
                body: material,
                headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
                },
            }),
            invalidatesTags: ['Materials']
        }),
        deleteMaterial: builder.mutation({
          query: ({id}) => ({
              url: `materials/${id}`,
              method: 'DELETE',
              body: id,
              headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
              }
          }),
          invalidatesTags: ['Materials']
      }),


        //*STORAGE API ENDPOINTS
        getAllStorages: builder.query({
            query: () => ({
                url: `storages`,
                headers: {
                    'Authorization': `Bearer ${userToken?.accessToken}`
                }
              }),
            providesTags: ['Storages']
          }),
          getStorage: builder.query({
            query: (userId) => ({
              url: `storages/find/${userId}`,
              headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
              }
            }),
          }),
          addStorage: builder.mutation({
              query: (storage) => ({
                  url: 'storages',
                  method: 'POST',
                  body: storage,
                  headers: {
                    'Authorization': `Bearer ${userToken?.accessToken}`
                  }
              }),
              invalidatesTags: ['Storages']
          }),
          updateStorage: builder.mutation({
              query: (storage) => ({
                  url: `storages/${storage._id}`,
                  method: 'PUT',
                  body: storage,
                  headers: {
                    'Authorization': `Bearer ${userToken?.accessToken}`
                  },
              }),
              invalidatesTags: ['Storages']
          }),
          deleteStorage: builder.mutation({
            query: ({id}) => ({
                url: `storages/${id}`,
                method: 'DELETE',
                body: id,
                headers: {
                    'Authorization': `Bearer ${userToken?.accessToken}`
                }
            }),
            invalidatesTags: ['Storages']
        }),

        //*COLOR API ENDPOINTS
            getAllColors: builder.query({
                query: () => ({
                    url: `colors`,
                    headers: {
                        'Authorization': `Bearer ${userToken?.accessToken}`
                    }
                  }),
                providesTags: ['Colors']
              }),
              getColor: builder.query({
                query: (userId) => ({
                  url: `colors/find/${userId}`,
                  headers: {
                      'Authorization': `Bearer ${userToken?.accessToken}`
                  }
                }),
              }),
              addColor: builder.mutation({
                  query: (color) => ({
                      url: 'colors',
                      method: 'POST',
                      body: color,
                      headers: {
                        'Authorization': `Bearer ${userToken?.accessToken}`
                      }
                  }),
                  invalidatesTags: ['Colors']
              }),
              updateColor: builder.mutation({
                  query: (color) => ({
                      url: `colors/${color._id}`,
                      method: 'PUT',
                      body: color,
                      headers: {
                        'Authorization': `Bearer ${userToken?.accessToken}`
                      },
                  }),
                  invalidatesTags: ['Colors']
              }),
              deleteColor: builder.mutation({
                query: ({id}) => ({
                    url: `colors/${id}`,
                    method: 'DELETE',
                    body: id,
                    headers: {
                        'Authorization': `Bearer ${userToken?.accessToken}`
                    }
                }),
                invalidatesTags: ['Colors']
            }),


      //*MODEL API ENDPOINTS
        getAllModels: builder.query({
          query: () => ({
              url: `models`,
              headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
              }
            }),
          providesTags: ['Models']
        }),
        addModel: builder.mutation({
            query: (material) => ({
                url: 'models',
                method: 'POST',
                body: material,
                headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
                }
            }),
            invalidatesTags: ['Models']
        }),
        updateModel: builder.mutation({
            query: (material) => ({
                url: `models/${material._id}`,
                method: 'PUT',
                body: material,
                headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
                },
            }),
            invalidatesTags: ['Models']
        }),
        deleteModel: builder.mutation({
          query: ({id}) => ({
              url: `models/${id}`,
              method: 'DELETE',
              body: id,
              headers: {
                  'Authorization': `Bearer ${userToken?.accessToken}`
              }
          }),
          invalidatesTags: ['Models']
      }),





            //*CATEGORY API ENDPOINTS
                  getAllGroups: builder.query({
                    query: () => ({
                        url: `groups`,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                      }),
                    providesTags: ['Groups']
                  }),
                  getGroup: builder.query({
                    query: (userId) => ({
                      url: `groups/find/${userId}`,
                      headers: {
                          'Authorization': `Bearer ${userToken?.accessToken}`
                      }
                    }),
                  }),
                  addGroup: builder.mutation({
                      query: (group) => ({
                          url: 'groups',
                          method: 'POST',
                          body: group,
                          headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                          }
                      }),
                      invalidatesTags: ['Groups']
                  }),
                  updateGroup: builder.mutation({
                      query: (group) => ({
                          url: `groups/${group._id}`,
                          method: 'PUT',
                          body: group,
                          headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                          },
                      }),
                      invalidatesTags: ['Groups']
                  }),
                  deleteGroup: builder.mutation({
                    query: ({id}) => ({
                        url: `groups/${id}`,
                        method: 'DELETE',
                        body: id,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                    }),
                    invalidatesTags: ['Groups']
                }),

                //*CHARGER API ENDPOINTS
                getAllChargers: builder.query({
                    query: () => ({
                        url: `chargers`,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                      }),
                    providesTags: ['Chargers']
                  }),
                  getCharger: builder.query({
                    query: (userId) => ({
                      url: `chargers/find/${userId}`,
                      headers: {
                          'Authorization': `Bearer ${userToken?.accessToken}`
                      }
                    }),
                  }),
                  getAllActiveChargers: builder.query({
                    query: () => `chargers/active`,
                    providesTags: ['ActiveChargers']
                  }),
                  getAllInactiveChargers: builder.query({
                    query: () => `chargers/inactive`,
                    providesTags: ['InactiveChargers']
                  }),
                  addCharger: builder.mutation({
                      query: (charger) => ({
                          url: 'chargers',
                          method: 'POST',
                          body: charger,
                          headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                          }
                      }),
                      invalidatesTags: ['Chargers','InactiveChargers', 'ActiveChargers']
                  }),
                  updateCharger: builder.mutation({
                      query: (charger) => ({
                          url: `chargers/${charger._id}`,
                          method: 'PUT',
                          body: charger,
                          headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                          },
                      }),
                      invalidatesTags: ['Chargers','InactiveChargers', 'ActiveChargers']
                  }),
                  deleteCharger: builder.mutation({
                    query: ({id}) => ({
                        url: `chargers/${id}`,
                        method: 'DELETE',
                        body: id,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                    }),
                    invalidatesTags: ['Chargers','InactiveChargers', 'ActiveChargers']
                }),

                //*HEADPHONES API ENDPOINTS
                getAllHeadphones: builder.query({
                    query: () => ({
                        url: `headphones`,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                      }),
                    providesTags: ['Headphones']
                  }),
                  getAllActiveHeadphones: builder.query({
                    query: () => `headphones/active`,
                    providesTags: ['ActiveHeadphones']
                  }),
                  getAllInactiveHeadphones: builder.query({
                    query: () => `headphones/inactive`,
                    providesTags: ['InactiveHeadphones']
                  }),
                  getHeadphone: builder.query({
                    query: (userId) => ({
                      url: `headphones/find/${userId}`,
                      headers: {
                          'Authorization': `Bearer ${userToken?.accessToken}`
                      }
                    }),
                  }),
                  addHeadphone: builder.mutation({
                    query: (headphone) => ({
                        url: 'headphones',
                        method: 'POST',
                        body: headphone,
                        headers: {
                          'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                    }),
                    invalidatesTags: ['Headphones','InactiveHeadphones', 'ActiveHeadphones']
                }),
                  updateHeadphone: builder.mutation({
                      query: (headphone) => ({
                          url: `headphones/${headphone._id}`,
                          method: 'PUT',
                          body: headphone,
                          headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                          },
                      }),
                      invalidatesTags: ['Headphones','InactiveHeadphones', 'ActiveHeadphones']
                  }),
                  deleteHeadphone: builder.mutation({
                    query: ({id}) => ({
                        url: `headphones/${id}`,
                        method: 'DELETE',
                        body: id,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                    }),
                    invalidatesTags: ['Headphones','InactiveHeadphones', 'ActiveHeadphones']
                }),

                //*PHONECASES API ENDPOINTS
                getAllPhonecases: builder.query({
                    query: () => ({
                        url: `phonecases`,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                      }),
                    providesTags: ['Phonecases']
                  }),
                  getAllActivePhonecases: builder.query({
                    query: () => `phonecases/active`,
                    providesTags: ['ActivePhonecases']
                  }),
                  getAllInactivePhonecases: builder.query({
                    query: () => `phonecases/inactive`,
                    providesTags: ['InactivePhonecases']
                  }),
                  getPhonecase: builder.query({
                    query: (userId) => ({
                      url: `phonecases/find/${userId}`,
                      headers: {
                          'Authorization': `Bearer ${userToken?.accessToken}`
                      }
                    }),
                  }),
                  addPhonecase: builder.mutation({
                      query: (phonecase) => ({
                          url: 'phonecases',
                          method: 'POST',
                          body: phonecase,
                          headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                          }
                      }),
                      invalidatesTags: ['Phonecases','InactivePhonecases', 'ActivePhonecases']
                  }),
                  updatePhonecase: builder.mutation({
                      query: (phonecase) => ({
                          url: `phonecases/${phonecase._id}`,
                          method: 'PUT',
                          body: phonecase,
                          headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                          },
                      }),
                      invalidatesTags: ['Phonecases','InactivePhonecases', 'ActivePhonecases']
                  }),
                  deletePhonecase: builder.mutation({
                    query: ({id}) => ({
                        url: `phonecases/${id}`,
                        method: 'DELETE',
                        body: id,
                        headers: {
                            'Authorization': `Bearer ${userToken?.accessToken}`
                        }
                    }),
                    invalidatesTags: ['Phonecases','InactivePhonecases', 'ActivePhonecases']
                }),



  //*ADDRESS API ENDPOINTS
    getUserAddresses: builder.query({
      query: ({id}) => ({
        url: `addresses/find/${id}`,
        headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
        }
      }),
      providesTags: ['Addresses']
    }),
    addAddress: builder.mutation({
        query: (address) => ({
            url: 'addresses',
            method: 'POST',
            body: address,
            headers: {
              'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
        invalidatesTags: ['Addresses']
    }),
    updateAddress: builder.mutation({
        query: (address) => ({
            url: `addresses/${address._id}`,
            method: 'PUT',
            body: address,
            headers: {
              'Authorization': `Bearer ${userToken?.accessToken}`
            },
        }),
        invalidatesTags: ['Addresses']
    }),
    deleteAddress: builder.mutation({
      query: ({id}) => ({
          url: `addresses/${id}`,
          method: 'DELETE',
          body: id,
          headers: {
              'Authorization': `Bearer ${userToken?.accessToken}`
          }
      }),
      invalidatesTags: ['Addresses']
  }),


  //*FAVORITE API ENDPOINTS
  getAllFavorites: builder.query({
    query: () => ({
        url: `favorites`,
        headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
        }
      }),
    providesTags: ['Favorites']
  }),
  getUserFavorites: builder.query({
    query: (userId) => ({
      url: `favorites/find/${userId}`,
      headers: {
          'Authorization': `Bearer ${userToken?.accessToken}`
      }
    }),
  }),
  addFavorite: builder.mutation({
      query: (favorite) => ({
          url: 'favorites',
          method: 'POST',
          body: favorite,
          headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
          }
      }),
  }),
    updateFavorite: builder.mutation({
      query: (favorite) => ({
          url: `favorites/${favorite._id}`,
          method: 'PUT',
          body: favorite,
          headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
          },
      }),
  }),
  deleteFavorite: builder.mutation({
    query: ({id}) => ({
        url: `favorites/${id}`,
        method: 'DELETE',
        body: id,
        headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
        }
    }),
}),

  getAllItems: builder.query({
    query: () => ({
        url: `allItems`,
        headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
        }
      }),
    providesTags: ['allItems']
  }),

    //*PRODUCT API ENDPOINTS
    getAllPopularProducts: builder.query({
        query: () => `popularProducts`,
        providesTags: ['PopularProducts']
    }),
    addPopularProduct: builder.mutation({
        query: (smartphone) => ({
            url: 'popularProducts',
            method: 'POST',
            body: smartphone,
            headers: {
                'Authorization': `Bearer ${userToken?.accessToken}`
            }
        }),
    }),
    updatePopularProduct: builder.mutation({
      query: (popularProduct) => ({
          url: `popularProducts/${popularProduct}`,
          method: 'PUT',
          body: popularProduct,
          headers: {
            'Authorization': `Bearer ${userToken?.accessToken}`
          },
      }),
      invalidatesTags: ['PopularProducts']
  }),
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
  useGetAllOrdersQuery, useGetUserOrdersQuery, useGetOrderQuery, useAddOrderMutation, useUpdateOrderMutation, useDeleteOrderMutation, 
  useGetAllSmartphonesQuery, useGetAllActiveSmartphonesQuery, useGetAllInactiveSmartphonesQuery, useGetSmartphoneQuery, useAddSmartphoneMutation, useUpdateSmartphoneMutation, useDeleteSmartphoneMutation, 
  useGetAllUsersQuery, useGetUserQuery, useUpdateUserMutation, useDeleteUserMutation, 
  useGetAllCartsQuery, useGetCartQuery, useAddCartMutation, useUpdateCartMutation, useDeleteCartMutation, 
  useGetAllBrandsQuery, useGetBrandQuery, useAddBrandMutation, useUpdateBrandMutation, useDeleteBrandMutation,
  useGetAllStoragesQuery, useGetStorageQuery, useAddStorageMutation, useUpdateStorageMutation, useDeleteStorageMutation, 
  useGetAllColorsQuery, useGetColorQuery, useAddColorMutation, useUpdateColorMutation, useDeleteColorMutation,
  useGetAllMaterialsQuery, useAddMaterialMutation, useUpdateMaterialMutation, useDeleteMaterialMutation,
  useGetAllModelsQuery, useAddModelMutation, useUpdateModelMutation, useDeleteModelMutation,
  useGetAllGroupsQuery, useGetGroupQuery, useAddGroupMutation, useUpdateGroupMutation, useDeleteGroupMutation, 
  useGetAllChargersQuery, useGetChargerQuery, useGetAllActiveChargersQuery, useGetAllInactiveChargersQuery, useAddChargerMutation, useUpdateChargerMutation, useDeleteChargerMutation,
  useGetAllHeadphonesQuery, useGetHeadphoneQuery, useGetAllActiveHeadphonesQuery, useGetAllInactiveHeadphonesQuery, useAddHeadphoneMutation, useUpdateHeadphoneMutation, useDeleteHeadphoneMutation,
  useGetAllPhonecasesQuery, useGetAllActivePhonecasesQuery, useGetAllInactivePhonecasesQuery, useGetPhonecaseQuery, useAddPhonecaseMutation, useUpdatePhonecaseMutation, useDeletePhonecaseMutation,
  useGetUserAddressesQuery, useAddAddressMutation, useUpdateAddressMutation, useDeleteAddressMutation, 
  useGetUserFavoritesQuery, useAddFavoriteMutation, useUpdateFavoriteMutation, useDeleteFavoriteMutation, useGetAllFavoritesQuery, 
  useGetAllItemsQuery, useGetAllPopularProductsQuery, useAddPopularProductMutation, useUpdatePopularProductMutation} = fullApi;